import {UserAuthWrapper} from "redux-auth-wrapper"
import {routerActions} from "react-router-redux"
import {effectiveApplications, ROLE_ADMIN, ROLE_OPS} from '../constants'
import React, {Component} from "react"

export const containsCogoland = (a)=>{
  const licenses = a.licenses || []

  const result = !_.isNil(_.find(licenses, (l)=>{
    const applications = effectiveApplications(l)
    return !_.isNil(_.find(applications, (a)=>{return a.name === 'cogoland'}))
  }))
  
  return result
}

export const predicateFunctions = {
  UserIsAuthenticated: (x) => (x.access_token !== undefined),
  UserIsEnterprise: (x) => {
    return x.employers && x.employers.filter((a)=>containsCogoland(a)).length > 0
  },
  UserIsAdmin: (x) => {
    return x.roles && x.roles.includes(ROLE_ADMIN)
  },
  UserIsAdminOrOps: (x) => {
    return x.roles && (x.roles.includes(ROLE_ADMIN) || x.roles.includes(ROLE_OPS))
  },
  UserIsPaid: (x) => {
    return x.userType && x.userType.name === 'PAID'
  },
  UserIsNotAuthenticated: (x) => (x.access_token === undefined)

}

export const UserIsAuthenticated = UserAuthWrapper({
  authSelector: state => state.user,
  redirectAction: routerActions.replace,
  failureRedirectPath: '/login',
  allowRedirectBack: false,
  wrapperDisplayName: 'UserIsAuthenticated',
  predicate: predicateFunctions['UserIsAuthenticated']
})

export const UserIsEnterprise = UserAuthWrapper({
  authSelector: state => state.user,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsEnterprise',
  failureRedirectPath: '/accessDenied',
  allowRedirectBack: false,
  FailureComponent: null,
  predicate: predicateFunctions['UserIsEnterprise']
})

export const UserIsAdmin = UserAuthWrapper({
  authSelector: state => state.user,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsAdmin',
  failureRedirectPath: '/',
  allowRedirectBack: false,
  FailureComponent: null,
  predicate: predicateFunctions['UserIsAdmin']
})


export const UserIsAdminOrOps = UserAuthWrapper({
  authSelector: state => state.user,
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'UserIsAdminOrOps',
  failureRedirectPath: '/',
  allowRedirectBack: false,
  FailureComponent: null,
  predicate: predicateFunctions['UserIsAdminOrOps']
})


export const UserIsPaid = UserAuthWrapper({
  authSelector: state => state.user,
  wrapperDisplayName: 'UserIsPaid',
  FailureComponent: React.createClass({render: ()=>(<h3>Only Available to Premium Accounts</h3>)}),
  predicate: predicateFunctions['UserIsPaid']
})

export const UserIsNotAuthenticated = UserAuthWrapper({
  authSelector: state => state.user,
  redirectAction: routerActions.replace,
  failureRedirectPath: '/',
  allowRedirectBack: false,
  wrapperDisplayName: 'UserIsNotAuthenticated',
  predicate: predicateFunctions['UserIsNotAuthenticated']
})



// WEBPACK FOOTER //
// ./src/routes/AuthWrappers.js